import { PARTNERSHIP_CONSTANTS } from "./constants";
import { Box, GridItem, Heading, Highlight, SimpleGrid, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import PageLayout from "@/layouts/pageLayout";
const PartnershipComponent = () => {
  const textVariant = useTextVariants();
  return (
    <Box bgColor={"#EDF2F7"} p={12}>
      <PageLayout>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={16}>
          <GridItem colSpan={{ base: 1, sm: 2, md: 1 }} alignSelf={"center"}>
            <Heading as="h2" fontWeight={"400"} fontSize={"40px"}>
              {PARTNERSHIP_CONSTANTS.title}
            </Heading>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 2, md: 3 }} alignSelf={"center"}>
            <Text
              variant={textVariant}
              color="text.100"
              fontSize={"20px"}
              lineHeight={"30px"}
            >
              <Highlight
                query={PARTNERSHIP_CONSTANTS.desc.highlight}
                styles={{ fontWeight: 600, color: "text.100" }}
              >
                {PARTNERSHIP_CONSTANTS.desc.text}
              </Highlight>
            </Text>
          </GridItem>
        </SimpleGrid>
      </PageLayout>
    </Box>
  );
};

export default PartnershipComponent;
